import { LocationStrategy } from '@angular/common';
import { QueryLocationStrategyService } from './query-location-strategy.service';
import { NGX_ROUTE_OPTIONS } from './route-query-name.token';
import { ExtraOptions } from './types';

export const locationStrategy = (options?: ExtraOptions) => {
  const { routeQueryName = 'app', stickyParams = [] } = options || {};

  return [
    {
      provide: LocationStrategy,
      useClass: QueryLocationStrategyService,
    },
    {
      provide: NGX_ROUTE_OPTIONS,
      useValue: { stickyParams, routeQueryName },
    },
  ];
};
